import { defaultOptionTypes } from '@/ui/components/Form/Select/types';
import { SelectOption } from '@/ui/members/components/form/SelectDialog/types';

export const AnalyticsTrackingEvents = {
  buttonPressed: (buttonName: string) => `Pressed: ${buttonName}`,
  radioSelected: (id: string, value: defaultOptionTypes) => `Selected: ${id} - ${value}`,
  checkboxClicked: (id: string, value: boolean) => `Clicked: ${id} - ${value}`,
  comboboxSelected: (id: string, option: SelectOption) =>
    `Selected: ${id} - ${option.label} - ${option.label}`,
  error: (errorMessage: string, screenName?: string) =>
    `Error: ${errorMessage}${screenName ? ` on ${screenName}` : ''}`
};
